import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter" }
const _hoisted_2 = { class: "gfu-grid__cell gfu-1of1 gfu-4of6--m gfu-left-1of6--m gfu-1of1 gfu-10of12--l gfu-left-1of12--l gfu-1of2--xl gfu-left-3of12--xl" }
const _hoisted_3 = {
  class: "gfu-box _mt-6 _mb-3",
  "data-qa": "welcome-user-message-header"
}
const _hoisted_4 = {
  class: "gfu-heading gfu-heading--soft gfu-box__title gfu-box__title--success _mb-3",
  "data-qa": "join-project-confirmation:header"
}
const _hoisted_5 = { class: "_tac" }
const _hoisted_6 = { class: "_tac _mt-6" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "_tac _mb-6"
}
const _hoisted_9 = { "format-key": "0" }
const _hoisted_10 = { "format-key": "1" }
const _hoisted_11 = { class: "_tac _mb-3" }
const _hoisted_12 = { class: "gfu-table__row _pr-0 _tal" }
const _hoisted_13 = { class: "gfu-table__cell gfu-table__cell--centered gfu-table__cell--image _mr-3" }
const _hoisted_14 = { class: "gfu-table__thumb" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "gfu-table__cell gfu-table__cell--grow _tal" }
const _hoisted_17 = { class: "gfu-table__text--big" }
const _hoisted_18 = { class: "gfu-table__text--strong gfu-table__text--big" }
const _hoisted_19 = {
  key: 2,
  class: "_tac _mt-6"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = ["action"]
const _hoisted_22 = { class: "_mb-6" }
const _hoisted_23 = { class: "_tac _mb-3" }
const _hoisted_24 = { class: "_tac _mb-3" }
const _hoisted_25 = { class: "gfu-field gfu-field--inline _mr-3" }
const _hoisted_26 = { class: "gfu-field__toggle gfu-field-toggle gfu-field-toggle--radio" }
const _hoisted_27 = { class: "gfu-field-toggle__label" }
const _hoisted_28 = { class: "gfu-field-toggle__label-text" }
const _hoisted_29 = { class: "gfu-field gfu-field--inline" }
const _hoisted_30 = { class: "gfu-field__toggle gfu-field-toggle gfu-field-toggle--radio" }
const _hoisted_31 = { class: "gfu-field-toggle__label" }
const _hoisted_32 = { class: "gfu-field-toggle__label-text" }
const _hoisted_33 = {
  key: 1,
  class: "_tac _mb-3"
}
const _hoisted_34 = { class: "gfu-field gfu-field--inline" }
const _hoisted_35 = { class: "gfu-field__toggle gfu-field-toggle" }
const _hoisted_36 = ["checked"]
const _hoisted_37 = { class: "gfu-field-toggle__label _tal" }
const _hoisted_38 = { class: "gfu-field-toggle__label-text" }
const _hoisted_39 = { class: "_tac" }
const _hoisted_40 = {
  type: "submit",
  class: "gfu-btn gfu-btn--accent gfu-btn--wide gfu-btn--soft"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_content_renderer = _resolveComponent("content-renderer")
  const _component_localize = _resolveComponent("localize")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, { class: "gfu-layout-wrapper" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString($options.header), 1 /* TEXT */),
            ($props.welcomeUserMessage)
              ? (_openBlock(), _createBlock(_component_content_renderer, {
                  key: 0,
                  class: "gfu-box__section gfu-richtext",
                  content: $props.welcomeUserMessage,
                  "data-qa": "join-project-confirmation:welcome-user-message"
                }, null, 8 /* PROPS */, ["content"]))
              : _createCommentVNode("v-if", true),
            ($options.isV2Project)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.Resources.format(_ctx.Resources.JoinProject.ManageYourPledgeParagraph, $props.projectName)), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", {
                      class: "gfu-btn gfu-btn--accent gfu-btn--wide gfu-btn--soft",
                      href: $props.urlYourPledge
                    }, _toDisplayString(_ctx.Resources.JoinProject.ViewYourPledgeButton), 9 /* TEXT, PROPS */, _hoisted_7)
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  ($props.hasUserCreditBalance)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_localize, {
                          resource: _ctx.Resources.JoinProject.CreditsGrantedToAccountParagraph
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_9, _toDisplayString($props.projectName), 1 /* TEXT */),
                            _createElementVNode("strong", _hoisted_10, _toDisplayString($props.userCreditBalance), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["resource"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($props.predefinedCartItems.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.Resources.format(_ctx.Resources.JoinProject.PledgeCreatedByCreatorIntro, $props.projectName)), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.predefinedCartItems, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "gfu-table gfu-table__row--dark gfu-product__actions__item"
                          }, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("img", {
                                    src: item.imageUrl,
                                    alt: item.productName
                                  }, null, 8 /* PROPS */, _hoisted_15)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(item.quantity) + "x ", 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(item.productName), 1 /* TEXT */)
                              ])
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  ($props.continueDirectlyToHome)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("a", {
                          class: "gfu-btn gfu-btn--accent gfu-btn--wide gfu-btn--soft",
                          href: $props.urlProjectHome
                        }, _toDisplayString(_ctx.Resources.JoinProject.ContinueToProjectHomeButton), 9 /* TEXT, PROPS */, _hoisted_20)
                      ]))
                    : (_openBlock(), _createElementBlock("form", {
                        key: 3,
                        method: "post",
                        action: $props.actionForm
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          (!$props.cannotDiscardCard)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.Resources.JoinProject.PledgeCreatedByCreatorFollowUpParagraph), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("label", _hoisted_26, [
                                      _cache[1] || (_cache[1] = _createElementVNode("input", {
                                        class: "gfu-field-toggle__input",
                                        type: "radio",
                                        name: "keepItems",
                                        value: "true",
                                        checked: "true"
                                      }, null, -1 /* CACHED */)),
                                      _createElementVNode("span", _hoisted_27, [
                                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-field-toggle__icon" }, null, -1 /* CACHED */)),
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.Resources.JoinProject.KeepPledgeCreatedByCreatorOption), 1 /* TEXT */)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("label", _hoisted_30, [
                                      _cache[3] || (_cache[3] = _createElementVNode("input", {
                                        class: "gfu-field-toggle__input",
                                        type: "radio",
                                        name: "keepItems",
                                        value: "false"
                                      }, null, -1 /* CACHED */)),
                                      _createElementVNode("span", _hoisted_31, [
                                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "gfu-field-toggle__icon" }, null, -1 /* CACHED */)),
                                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.Resources.JoinProject.DiscardPledgeCreatedByCreatorOption), 1 /* TEXT */)
                                      ])
                                    ])
                                  ])
                                ])
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          ($props.enableAdditionalCommunicationConsent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("label", _hoisted_35, [
                                    _createElementVNode("input", {
                                      class: "gfu-field-toggle__input",
                                      type: "checkbox",
                                      name: "externalCommunicationConsent",
                                      value: "true",
                                      checked: $props.isChecked
                                    }, null, 8 /* PROPS */, _hoisted_36),
                                    _createElementVNode("span", _hoisted_37, [
                                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "gfu-field-toggle__icon" }, null, -1 /* CACHED */)),
                                      _createElementVNode("span", _hoisted_38, [
                                        _createElementVNode("span", null, [
                                          _createElementVNode("span", null, [
                                            _createTextVNode(_toDisplayString(_ctx.Resources.JoinProject.CreatorEmailCommunicationConsentLabel) + " ", 1 /* TEXT */),
                                            _createVNode(_component_tooltip, { text: $options.tooltipText }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("em", null, [
                                                  _createVNode(_component_base_icon, { name: "circle-info" })
                                                ])
                                              ]),
                                              _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["text"])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("button", _hoisted_40, _toDisplayString(_ctx.Resources.JoinProject.ContinueToProjectHomeButton), 1 /* TEXT */)
                        ])
                      ], 8 /* PROPS */, _hoisted_21))
                ], 64 /* STABLE_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}